import { ManageElement } from "./ManageElement";
import { CustomerStore } from "stores/CustomerStore";
import { observable } from "mobx";

export class Customer extends ManageElement {
  static _store: CustomerStore;

  @observable customer_number!: number;
}
